/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, message } from 'antd';
import { v4 as uuid } from 'uuid';

const { Option } = Select;

const ChildrenColumnCustomization = (props) => {
  const [childProperties, setChildProperties] = useState(props.childProperties || []);
  const columnIndex = props.index;

  useEffect(() => {
    setChildProperties(props.childProperties);
  }, [props.childProperties]);

  const childrenMapping = (childProperties, marginLeft, marginTop) => {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      }
    };

    return (
      <div>
        {childProperties.map((item, index) => (
          <Form
            key={index}
            style={{
              marginLeft,
              marginTop,
              border: '1px dashed #0b0a0a',
              padding: '18px'
            }}
            {...formItemLayout}
          >
            {item.title}
            <Form.Item
              label="Title :"
              rules={[{ required: true, message: 'Please Input Title!' }]}
            >
              <Input
                value={item.title}
                onChange={(e) =>
                  handleFieldChange(childProperties, e.target.value, index, item.id, 'title')
                }
              />
            </Form.Item>
            <Form.Item label="DataIndex :">
              <Input
                value={item.dataIndex}
                onChange={(e) =>
                  handleFieldChange(childProperties, e.target.value, index, item.id, 'dataIndex')
                }
              />
            </Form.Item>
            <Form.Item label="Key :">
              <Input
                value={item.key}
                onChange={(e) =>
                  handleFieldChange(childProperties, e.target.value, index, item.id, 'key')
                }
              />
            </Form.Item>
            <Form.Item label="Width :">
              <Input
                style={{ width: '100%' }}
                value={item.width}
                type="number"
                onChange={(e) =>
                  handleFieldChange(childProperties, e.target.value, index, item.id, 'width')
                }
              />
            </Form.Item>
            <Form.Item label="ClassName :">
              <Select
                style={{ width: '100%' }}
                value={item.className}
                onSelect={(value) =>
                  handleFieldChange(childProperties, value, index, item.id, 'className')
                }
              >
                <Option value="table-column"> TABLE-COLUMN </Option>
              </Select>
            </Form.Item>

            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '18px' }}>
              <Button
                id={item.id}
                type="primary"
                style={{ margin: '2px' }}
                onClick={(e) => subChildrenSave(childProperties, e.target.id)}
              >
                Save
              </Button>
              <Button
                id={item.id}
                type="danger"
                style={{ margin: '2px' }}
                onClick={(e) => subChildDelete(childProperties, index, e.target.id)}
              >
                Delete
              </Button>
              <Button
                id={item.id}
                type="primary"
                style={{ margin: '2px' }}
                onClick={(e) => subChildrenAddition(childProperties, e.target.id, index)}
              >
                Add SubChildren
              </Button>
            </div>

            {item.children ? childrenMapping(item.children, '100px') : null}
          </Form>
        ))}
      </div>
    );
  };

 const addSubChildren = (childObj, index, id, key) =>{
    let array = [];
    if (childObj.children) {
      if (childObj.id === id && childObj.key === key) {
        if (childObj.title === '' || childObj.dataIndex === '' || childObj.key === '') {
          message.error('Please Enter All Thes Fields');
        } else {
          let newObj = {
            id: uuid(),
            title: 'subChildren',
            dataIndex: '',
            key: '',
            width: '100',
            className: '',
            background: ''
          };
          childObj.children.push(newObj);
        }
      } else {
        subChildrenAddition(childObj.children, id, index, key);
      }
    } else {
      if (childObj.id === id && childObj.key === key) {
        if (childObj.title === '' || childObj.dataIndex === '' || childObj.key === '') {
          message.error('Please Enter All Thes Fields');
        } else {
          let newObj = {
            id: uuid(),
            title: 'subChildren',
            dataIndex: '',
            key: '',
            width: '100',
            className: '',
            background: ''
          };
          array.push(newObj);
          childObj['children'] = array;
        }
      }
    }
  };

  const subChildrenAddition = (childProperties, id, key) => {
    if (id === '') {
      id = undefined;
    }

    childProperties &&
    Array.isArray(childProperties) &&
    childProperties.map((item, index) => {
      let array = [];

      if (item && item.children && item.children.length > 0) {
        if (item.id === id && item.key === key) {
          if (item.title === '' || item.dataIndex === '' || item.key === '') {
            message.error('Please Enter All Thes Fields');
          } else {
            let newObj = {
              id: uuid(),
              title: 'subChildren',
              dataIndex: '',
              key: '',
              width: '100',
              className: '',
              background: ''
            };
            item.children.push(newObj);
          }
        } else {
          item.children.map((childObj) => {
            addSubChildren(childObj, index, id, key);
            return {};
          });
        }
      } else {
        if (item.id === id && item.key === key) {
          if (item.title === '' || item.dataIndex === '' || item.key === '') {
            message.error('Please Enter All Thes Fields');
          } else {
            let newObj = {
              id: uuid(),
              title: 'subChildren',
              dataIndex: '',
              key: '',
              width: '100',
              className: '',
              background: ''
            };
            array.push(newObj);
            item['children'] = array;
          }
        }
      }

      props.submitChildren(childProperties, columnIndex);
      setChildProperties(childProperties);
      return {};
    });
  };

  const subChildrenSave = (childProperties, id) => {
    const updatedChildProperties = childProperties.map((item) => {
      if (item.id === id) {
        if (item.title === '' || item.dataIndex === '' || item.key === '') {
          message.error('Please Enter All These Fields');
        } else {
          message.success('children Saved successfully');
        }
      } else if (item.children) {
        subChildrenSave(item.children, id);
      }
      return item;
    });

    setChildProperties(updatedChildProperties);
    props.submitChildren(updatedChildProperties, columnIndex);
  };

  const subChildDelete = (childProperties, index, id) => {
    const updatedChildProperties = childProperties &&
    Array.isArray(childProperties) &&
    childProperties.map((item, index) => {
      if (item && item.children && item.children.length > 0) {
        if (item.id === id) {
          childProperties.splice(item, 1);
        } else {
          item.children.map((childObj) => {
            if (childObj.id === id) {
              item.children.splice(childObj, 1);
            } else {
              deleteSubChild(childObj, index, id);
            }
            return {};
          });
        }
      } else {
        if (item.id === id) {
          childProperties.splice(item, 1);
        }
      }
      
      return {};
    });

    setChildProperties(updatedChildProperties);
    props.submitChildren(updatedChildProperties, columnIndex);
  };

 const deleteSubChild = (childObj, index, id)=> {
    if (childObj.children) {
      if (childObj.id === id) {
        childObj.splice(childObj, 1);
        // childProperties.splice(childObj, 1);
      }
      subChildDelete(childObj.children, index, id);
    } else {
      if (childObj.id === id) {
        childObj.splice(childObj, 1);
        // childProperties.splice(childObj, 1);
      }
    }
  };

  const handleFieldChange = (childProperties, value, index, id, key) => {
    const updatedChildProperties = childProperties.map((item) => {
      if (item.id === id) {
        item[key] = value;
      } else if (item.children) {
        item.children = handleFieldChange(item.children, value, index, id, key);
      }
      return item;
    });

    setChildProperties(updatedChildProperties);
    props.submitChildren(updatedChildProperties, columnIndex);
  };

  return childrenMapping(childProperties, '20px', '20px');
};

export default ChildrenColumnCustomization;